module.exports = __webpack_public_path__ + "img/laddercontrol5.b8d50140.png";